import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CurrentUserStore } from '@app/user/store/current-user/current-user.store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserStoreReadyResolver implements Resolve<boolean> {
  constructor(private userStore: CurrentUserStore) {}

  resolve(): Observable<boolean> {
    return this.userStore.stateChanged.pipe(
      filter(state => !!state),
      take(1),
      map(_ => true)
    );
  }
}
